import { defineMessages } from 'react-intl';

export default defineMessages({
    policyLabel: {
        id: 'anonymous.authenticated.selectablePolicy.Policy',
        defaultMessage: 'Policy'
    }
});
